import { Injectable, Inject, OnDestroy } from '@angular/core';
import { PlatformDetect } from '@libs/platform/platform-detect';
import { CommonService } from './common.service';
import { AcpService } from '@services/common/acp.service';
import { ConfigInterface, CONFIG_OPTIONS } from '@libs/config/config-options';
import { initTy } from '@libs/tingyun';
import { FactoryService } from './factory.service';
import { TrackingInterface, SH_TRACKING} from '@libs/tracking';

declare const window: any;
@Injectable({
    providedIn: 'root'
})
export class InitAppService implements OnDestroy{
    public lang: string = 'zh-cn';
    private vConsole: any;

    constructor(
        private platform: PlatformDetect,
        private comSer: CommonService,
        private acpSer: AcpService,
        private factorySer: FactoryService,
        @Inject(SH_TRACKING) private trackIn: TrackingInterface,
        @Inject(CONFIG_OPTIONS) private config: ConfigInterface
    ) { }

    public async initApp() {
        const pathName = location.pathname;
        const wxAuthLoading = /(cookie-loading)/.test(pathName);
        // 微信授权回调页面不需要调用接口
        if (!wxAuthLoading) {
            this.initVConsole();
            this.lang = await this.factorySer.getLanguage();
            this.factorySer.setUrlParams(true);
            this.factorySer.setLimitType('refresh');
            await this.checkResource();
            await this.initConfigs();
        }
    }

    async initVConsole() { 
        const env = this.config.getEnv();
        if (!this.platform.isPcWeb() && (env === 'latest' || env === 'stage' || env === 'lt')) {
          import('vconsole').then(VConsole => {
            this.vConsole = new VConsole.default();
         });
        }
    }

    private async initConfigs() { 
        const config = await this.comSer.getConfigs();
        if (config) {
            const webConfig = config?.webConfig;
            this.factorySer.cdnUrl = webConfig ? `${webConfig?.cdnUrl}${this.factorySer.getEnv()}` : this.config.cdnUrl();
            this.factorySer.isPostMsg = config?.channelProperty?.POST_MESSAGE === 'true';
            this.setDynamicEle(config, webConfig);
            setTimeout(() => {
                initTy(config?.tingYun);
            }, 500);
        } else { 
            this.factorySer.cdnUrl = this.config.cdnUrl();
        }
    }

    private async checkResource() { 
        const pathName = window.location.pathname;
        const acpKey = /(guest-list)|(guest-edit)/.test(pathName) ? 'visitor' : /(license)/.test(pathName) ? 'license' : /(member)/.test(pathName) ? 'member' : null;
        const allFlag = /(guest-list)|(guest-edit)|(license)|(member)/.test(pathName) && !this.acpSer.acpData && !this.acpSer.fetchedAcp;
        const allRes = JSON.parse(sessionStorage.getItem(`allRes.${this.lang}`));
        const sessionData = allRes? allRes : JSON.parse(sessionStorage.getItem(`comRes.${this.lang}`));
        let acpData = this.getResource(acpKey, sessionData);
        if (!acpData || acpData === 'undefined') {
            acpData = await this.acpSer.initResource(acpKey, allFlag);
            if (acpData) { 
                this.comSer.setToggles(this.acpSer?.toggles); 
            }
        } else { 
            this.acpSer.setSessionData(acpData);
            this.acpSer.allResource = allFlag ? acpData : null;
            const toggles = acpData?.functionToggles;
            if (toggles) {
                this.acpSer.toggles = toggles;
                this.comSer.setToggles(toggles);  
            } else { 
                console.log('init no toggles..');
            }
        }
    }

    //check session data, if there is no data with acpKey in seeesion, then set acpData as null and re-trigger API to get reseource-data
    private getResource(acpKey: string, sessionData: any) { 
        return (acpKey === 'visitor' && !sessionData?.frequentContactMediaResource ||
            acpKey === 'license' && !sessionData?.carPlateMediaResource ||
            acpKey === 'member' && !sessionData?.memberTextResource) ? null : sessionData;
    }

    private async setDynamicEle(config: any, webConfig: any) { 
        const ele = document.getElementById('com-body');
        ele.lang = this.lang;
        window.env = config?.sensor?.appEnv || 'latest';     
        console.log('init env..', window.env);
        const trackJs = webConfig?.cdnUrl ? `${webConfig?.cdnUrl}${window.env}/${webConfig?.trackJs}` : '';
        this.setScript(trackJs);
        this.setLinks(webConfig ? `${webConfig?.cdnUrl}${webConfig?.fontsCss}` : this.config.inspireFontUrl());
        if (this.platform.isWx()) { 
            const wxJsUrl = webConfig ? `${webConfig?.cdnUrl}${window.env}/profile-web-ui/assets/jweixin.js` : this.config.getWxJs();
            this.setScript(wxJsUrl);
        }
        window.trackingEnable = config?.sensor?.trackingEnable || true;
        window.trackingPlatformTypeMap = config?.sensor?.trackingPlatformTypeMap;
        setTimeout(() => {
            console.log('init autoTrack..',window.autoTrack);
            if (window.trackingEnable && window.autoTrack) {
                this.trackIn.initTracking();
            }
        }, 300);
    }
    
    private setScript(url: string) { 
        try {
          const tmpScript = document.createElement('script');
          tmpScript.src = url? url : ''; 
          document.getElementsByTagName('body')[0].appendChild(tmpScript);
        } catch (err) { 
          console.log('Error setScript:', err);
        }
    }

    private setLinks(href: string) {
        try { 
          const tmpLink = document.createElement('link');
          tmpLink.href = href;
          tmpLink.rel = 'stylesheet';
          document.getElementsByTagName('head')[0].appendChild(tmpLink);  
        } catch (err) { 
          console.log('Error setScript:', err);
        }
    }

    ngOnDestroy() { 
        if (this.vConsole){
            this.vConsole.destroy();
        }
    }
  
}